// ---------------------------------------------------------------
// Outbox — the autonomous dispatcher's queue of composed actions.
// The autopilot reacts to each load's status change, composes the SOP
// broker email / driver message / alarm report, and drops it here.
// Because the operator chose an approval check, items sit as 'pending'
// until approved; once an email/SMS connector is wired at deployment the
// same items auto-send with no click. Stored in localStorage so it works
// entirely browser-side for now.
// ---------------------------------------------------------------

const KEY = 'dd-outbox';

function get() { try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch { return []; } }
function save(list) { localStorage.setItem(KEY, JSON.stringify(list.slice(-500))); }

export function getOutbox() { return get().sort((a, b) => (b.createdAt || '').localeCompare(a.createdAt || '')); }
export function pendingCount() { return get().filter((i) => i.status === 'pending').length; }

// Enqueue composed actions. Each item needs a stable `sig` (loadId+channel+kind)
// so the same transition is never queued twice while still pending/sent.
export function enqueue(items) {
  if (!items || !items.length) return 0;
  const list = get();
  const seen = new Set(list.map((i) => i.sig));
  let added = 0;
  items.forEach((it) => {
    if (!it.sig || seen.has(it.sig)) return;
    list.push({ id: `O${Date.now()}${Math.floor(Math.random() * 1000)}`, status: 'pending', createdAt: new Date().toISOString(), ...it });
    seen.add(it.sig);
    added++;
  });
  if (added) save(list);
  return added;
}

export function setStatus(id, status) {
  const list = get();
  const it = list.find((x) => x.id === id);
  if (it) { it.status = status; if (status === 'sent') it.sentAt = new Date().toISOString(); save(list); }
}

export function removeItem(id) { save(get().filter((x) => x.id !== id)); }
export function clearDone() { save(get().filter((x) => x.status === 'pending')); }
